import MemberOperatorProvider, { useMemberOperatorTaskContext } from './MemberOperatorProvider';
import MemberOperatorTask from './MemberOperatorTask';

const MemberOperator = Object.assign(MemberOperatorProvider, {
    Task: MemberOperatorTask,
});

export default MemberOperator;
export { useMemberOperatorTaskContext };
